export default class SatoUtils {
  constructor(url) {
    this.url = url
    this.resolve = null
  }
  open() {
    return new Promise((resolve) => {
      const socket = new WebSocket(this.url)
      socket.onclose = function (event) {
        console.info('onclose', event)
      }
      socket.onerror = function (event) {
        console.error('onerror', event)
      }

      socket.onmessage = (event) => {
        if (event.data !== 'Socket server connected' && this.resolve) {
          this.resolve(event.data)
          this.resolve = null
        }
      }

      socket.onopen = function (event) {
        resolve(event)
      }
      this.socket = socket
    })
  }
  send(data) {
    return new Promise((resolve) => {
      this.resolve = resolve
      this.socket.send(JSON.stringify(data))
    })
  }
  close() {
    this.socket.close()
  }
}
